import styled from 'styled-components';
import React from "react";

const Button = styled.p`
    font-size: ${props => props.fontSize ? props.fontSize : "12px!important"}
    margin: ${props => props.margin ? props.margin : "0em 0em 0em 0em"}
    font-family: ${props => props.fontFamily ? props.fontFamily : "RobotoBold"}
    color: ${props => props.fontColor ? props.fontColor : "#50626c"}
    border: ${props => props.border ? props.border : "1px solid #f0f0f0"}
    border-radius: ${props => props.borderRadius ? props.borderRadius : "15px"}
    padding: ${props => props.padding ? props.padding : "1.5% 0%"};
    border: ${props => props.text == "" ? "none" : "1px solid #f0f0f0"} 
    border-radius:15px;
    padding:1.5% 0%;
    width:${props => props.width == undefined ? "28%" : props.width}
    margin:auto;
    margin-bottom: ${props => props.marginBottom ? props.marginBottom : "0px"}
    text-align: center;
    font-weight: 
    ${props => props.normal ? "normal" : ""}
    ${props => props.bold ? "bold" : "bold"}
    ${props => props.bolder ? "bolder" : ""}
    ${props => props.lighter ? "lighter" : ""}
    ;
    font-style:
    ${props => props.normal ? "normal" : ""}
    ${props => props.italic ? "italic" : ""}
    ${props => props.oblique ? "oblique" : ""}
    ;
`


class ClaroSubtitleButton extends React.Component {

    constructor(props){
        super(props);
    }
    handleOnClick = (event) => {
        if(this.props.logicType == "sears" || this.props.logicType == "plans"){
            window.history.back();
        } else{
            document.getElementById("pagoDeServicios_amount_" + this.props.serviceName).focus();
        }
    }
    render(){
        const width = this.props.isContainerTelcel ? "40%" : "30%";
        let buttonBorderColor = this.props.isContainerTelcel 
            ? "1px solid #7b1fa2 !important" 
            : "1px solid #f0f0f0";

        return(
            <>
                {
                     (
                        this.props.selectedPlan &&
                        this.props.selectedPlan.promotions &&
                        !this.props.selectedPlan.promotions.PromotionAccountN2Change
                    ) || !this.props.selectedPlan
                        ?
                            <Button 
                                props={this.props}
                                onClick={this.handleOnClick}
                                text={this.props.text}
                                width={width}
                                fontFamily={this.props.isContainerTelcel ? "AMX-Bold" : undefined}
                                fontColor={this.props.isContainerTelcel ? "#7b1fa2" : undefined}
                                isContainerTelcel={this.props.isContainerTelcel}
                                border={buttonBorderColor}
                                padding={this.props.isContainerTelcel ? '9px 16px 7px 16px !important' : undefined}
                                fontSize={this.props.isContainerTelcel ? '13px' : undefined}
                                borderRadius={this.props.isContainerTelcel ? '25px !important' : undefined}
                                marginBottom={this.props.isContainerTelcel ? '25px' : undefined}>
                                {this.props.children}
                            </Button>
                        :
                           <></>
                }
            </>
           
        )
    }
}
export default ClaroSubtitleButton;


